import { render, staticRenderFns } from "./ShopShowItem.vue?vue&type=template&id=ccd96272&scoped=true&"
import script from "./ShopShowItem.vue?vue&type=script&lang=js&"
export * from "./ShopShowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd96272",
  null
  
)

export default component.exports